import { create } from 'zustand';

export interface Notification {
  id: number;
  type: string;
  title: string;
  body: string;
  linkUrl: string | null;
  isRead: boolean;
  createdAt: string;
}

interface NotifState {
  list: Notification[];
  unreadCount: number;
  setList: (list: Notification[]) => void;
  setUnreadCount: (n: number) => void;
  incrementUnread: () => void;
  markAsRead: (id: number) => void;
  markAllRead: () => void;
}

export const useNotifStore = create<NotifState>((set) => ({
  list: [],
  unreadCount: 0,
  setList: (list) =>
    set({
      list,
      unreadCount: list.filter((n) => !n.isRead).length,
    }),
  setUnreadCount: (n) => set({ unreadCount: n }),
  incrementUnread: () => set((s) => ({ unreadCount: s.unreadCount + 1 })),
  markAsRead: (id) =>
    set((state) => ({
      list: state.list.map((n) => (n.id === id ? { ...n, isRead: true } : n)),
      unreadCount: Math.max(0, state.unreadCount - 1),
    })),
  markAllRead: () =>
    set((state) => ({
      list: state.list.map((n) => ({ ...n, isRead: true })),
      unreadCount: 0,
    })),
}));
